"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { useCountdown } from "@/lib/utilHooks";
import { useEffect } from "react";

export default function Countdown({
  dateTimeString,
  className,
  lang = "de",
}: {
  dateTimeString: string;
  className?: string;
  lang: "de" | "en" | "br";
}) {
  const { days, hours, minutes, seconds } = useCountdown(dateTimeString);

  const daysText    = lang === "de" ? "tage"    : lang === "br" ? "dias"    : "days";
  const hoursText   = lang === "de" ? "STUNDEN" : lang === "br" ? "HORAS"   : "hours";
  const minutesText = lang === "de" ? "MINUTEN" : lang === "br" ? "MINUTOS" : "minutes";
  const secondsText = lang === "de" ? "SEKUNDEN": lang === "br" ? "SEGUNDOS": "seconds";

  useEffect(() => {
    console.log("dateTimeString", dateTimeString);
  }, [dateTimeString]);

  return (
    <div className="flex flex-col justify-center items-center">
      <div className={cn("grid grid-cols-4 w-full")}>
        {/* TAGE */}
        <div className={cn(
          "countdownUnitItem flex flex-col justify-center items-center border-r py-[2rem] lg:py-[3.44rem]",
          "border-[#103037]/10",
        )}>
          <div className="flex flex-col justify-center items-center">
            <h2 className="text-[6rem] lg:text-[7.25rem] tracking-[normal] leading-[90%] font-normal text-white">
              {days}
            </h2>
            <h6 className="font-[500] text-[1.375rem] lg:text-[1.5rem] leading-[90%] uppercase text-white/70">
              {daysText}
            </h6>
          </div>
        </div>
        {/* STUNDEN */}
        <div className={cn(
          "countdownUnitItem flex flex-col justify-center items-center border-r py-[2rem] lg:py-[3.44rem]",
          "border-[#103037]/10",
        )}>
          <div className="flex flex-col justify-center items-center">
            <h2 className="text-[6rem] lg:text-[7.25rem] tracking-[normal] leading-[90%] font-normal text-white">
              {hours}
            </h2>
            <h6 className="font-[500] text-[1.375rem] lg:text-[1.5rem] leading-[90%] uppercase text-white/70">
              {hoursText}
            </h6>
          </div>
        </div>
        {/* MINUTEN */}
        <div className={cn(
          "countdownUnitItem flex flex-col justify-center items-center border-r py-[2rem] lg:py-[3.44rem]",
          "border-[#103037]/10",
        )}>
          <div className="flex flex-col justify-center items-center">
            <h2 className="text-[6rem] lg:text-[7.25rem] tracking-[normal] leading-[90%] font-normal text-white">
              {minutes}
            </h2>
            <h6 className="font-[500] text-[1.375rem] lg:text-[1.5rem] leading-[90%] uppercase text-white/70">
              {minutesText}
            </h6>
          </div>
        </div>
        {/* SEKUNDEN */}
        <div className="countdownUnitItem flex flex-col justify-center items-center py-[2rem] lg:py-[3.44rem]">
          <div className="flex flex-col justify-center items-center">
            <h2 className="text-[6rem] lg:text-[7.25rem] tracking-[normal] leading-[90%] font-normal text-white">
              {seconds}
            </h2>
            <h6 className="font-[500] text-[1.375rem] lg:text-[1.5rem] leading-[90%] uppercase text-white/70">
              {secondsText}
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
}
